import React, { useState, useEffect, useContext } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./ManageProductDetail.css";

import { Container, Image, Row, Col, Card, Tabs, Tab, Table, Button, Form, Alert, ButtonGroup, Badge, Modal } from 'react-bootstrap';

import { auth, firestore } from "../../../Database/firebase";
// import { AuthContext } from "../Authentication/AuthProvider";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";


import { FaHeart, FaTruck, FaFacebookMessenger, FaStar, FaRegEye, FaRegEyeSlash, FaRegThumbsUp, FaThumbsUp, FaReply, FaRegHeart, FaRegCommentAlt } from "react-icons/fa";
import { BsStarFill, BsStarHalf, BsStar } from "react-icons/bs";

//Test useParams
import { useParams, Link, useNavigate } from "react-router-dom";


function ManageProductDetail() {

 
    let { productId } = useParams();

    const formatter = new Intl.NumberFormat('th', {
        style: 'currency',
        currency: 'THB',
        maximumSignificantDigits: 3,
    
      });


      const [data, setData] = useState([]);

  const [merchantID, setMerchantID] = useState("");
  //const [storeName, setStoreName] = useState("");
  const [productID, setProductID] = useState("");
  const [merchantName, setMerchantName] = useState("");
  const [productCaption, setProductCaption] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productSubCategory, setProductSubCategory] = useState("");
  const [productTypeCategory, setProductTypeCategory] = useState("");
  /* const [productRelease, setProductRelease] = useState(""); */
  // const [productID, setProductID] = useState("");
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productBadge, setProductBadge] = useState("");
  const [productFullPrice, setProductFullPrice] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productWebPrice, setProductWebPrice] = useState("");
  const [publicWebStatus, setPublicWebStatus] = useState("");
  const [productDiscount, setProductDiscount] = useState("");
  const [productImage, setProductImage] = useState("");
  const [productPdf, setProductPdf] = useState("");
  const [productKeyword, setProductKeyword] = useState("");
  const [productReciept, setProductReciept] = useState("");

  const [productRatingSum, setProductRatingSum] = useState(0);
  const [productRatingCount, setProductRatintCount] = useState(0);

  const [productRelease, setProductRelease] = useState("");
  const [productDate, setProductDate] = useState(Date);

  const [productType, setProductType] = useState("");

  const [wishlist, setWishlist] = useState([""]);

  const [productSamplePdf, setProductSamplePdf] = useState("");

  const [saleCount, setSaleCount] = useState("");

  const [pdfFilePath, setPdfFilePath] = useState("");

  const [couponcodeMerchantios, setCouponcodeMerchantios] = useState([""]);
  const [couponcodeUserios, setCouponcodeUserios] = useState([""]);

  let purchaseDate = new Date();


  useEffect(() => {
    
const firsPageRef = firestore
              .collection("product")
              .where("productID", "==", productId);
              
          firsPageRef.onSnapshot((snapshot) => {
              let tempDataArray = [];
              snapshot.docs.forEach((doc) => {

   
                    if (doc.exists) {
                        tempDataArray = [...tempDataArray,
                        {
                            
                        },
                    ];


                    setMerchantID(doc.data().merchantID);
                    setProductID(doc.data().productID);
                    setMerchantName(doc.data().merchantName);
                    setMerchantID(doc.data().merchantID);
                    setProductName(doc.data().productName);
                    setProductCaption(doc.data().productCaption);
                    setProductCategory(doc.data().productCategory);
                    setProductSubCategory(doc.data().productSubCategory);
                    setProductTypeCategory(doc.data().productTypeCategory);
                    setProductBadge(doc.data().productBadge);
                    setProductFullPrice(doc.data().productFullPrice);
                    setProductPrice(doc.data().productPrice);
                    setProductDiscount(doc.data().productDiscount);
                    setProductImage(doc.data().productImage);
                    setProductDescription(doc.data().productDescription);

                    setProductRelease(doc.data().productRelease);
                    setProductDate(doc.data().productDate.toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'long', day: 'numeric', weekday: 'short',}));

                    setProductRatintCount(doc.data().productRatingCount);
                    setProductRatingSum(doc.data().productRatingSum);

                    setProductType(doc.data().productType);

                    setSaleCount(doc.data().saleCount);

                    setWishlist(doc.data().wishlist);

                    setProductSamplePdf(doc.data().productSamplePdf);

                    setPdfFilePath(doc.data().pdfFilePath);
                    setProductPdf(doc.data().productPdf);

                    setProductKeyword(doc.data().productKeyword);

                    setProductWebPrice(doc.data().productWebPrice);
                    setPublicWebStatus(doc.data().publicWebStatus);

                    setCouponcodeMerchantios(doc.data().couponcodeMerchantios);
                    setCouponcodeUserios(doc.data().couponcodeUserios);
                    
                    
                    };

                });

            setData((oldDataArray) => tempDataArray);

        },

            (err) => {
                console.log(err);
            }
            
        );

    }, []);

 
  //QUERY MERCHNAT DATA
  const [displayMerchantName, setDisplayMerchantName] = useState("");
  const [profileMerchantImg, setProductMerchantImg] = useState("");
  const [description, setDescription] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [tiktok, setTiktok] = useState("");

  useEffect(() => {
    const userRef = firestore.collection("user");
    
      const query = userRef
      .where("uid", "==", merchantID);
            query
            .get()
            .then((querySnapshot) => {
                let tempDataArray =[];
                querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                        
                    setDisplayMerchantName(doc.data().displayName);
                    setProductMerchantImg(doc.data().profileImg);
                    setDescription(doc.data().description);
                    setFacebook(doc.data().facebook);
                    setInstagram(doc.data().instagram);
                    setYoutube(doc.data().youtube);
                    setTiktok(doc.data().tiktok);

                    };

                });

        },

            (err) => {
                console.log(err);
            }
            
        );

    
        

    }, [merchantID]);


// Query Comment
const [commentLists, setCommentLists] = useState([]);
const [currentCursor, setCurrentCursor] = useState("");

    useEffect(() => {
        const firsPageRef = firestore
            .collection("comment")
            .orderBy("commentDate", "desc")
            .where("productID", "==", productId)
            
            .limit(4);
        firsPageRef.onSnapshot((snapshot) => {
          let tempLists =[];
          snapshot.forEach((doc) => {
              if (doc.exists) {

                    const currentComment = {

                      id: doc.id,
                      commentProduct: doc.data().commentProduct,
                      commentRating: doc.data().commentRating, 
                      commentDate: doc.data().commentDate,
                      displayName: doc.data().displayName,
                      profileImg: doc.data().profileImg,  

                    };
                    tempLists = [...tempLists, currentComment];
                    
                }
            });


            setCommentLists((prv) => tempLists);
            const currentLenght = snapshot.docs.length;
            const currentCursorFromFirstPage = snapshot.docs[currentLenght - 1];
            setCurrentCursor(currentCursorFromFirstPage);
        })
    }, []);

    const onMoreComment = () => {
        const nextPageRef = firestore
            .collection("comment")
            .orderBy("commentDate", "desc")
            .where("productID", "==", productId)
            
            .limit(4);
        nextPageRef.onSnapshot((snapshot) => {
            const currentLenght = snapshot.docs.length;
            if (!currentCursor) {
                return;
            }
            const query = nextPageRef.startAfter(currentCursor);
            query.get().then((snapshot) => {
                let tempNewArray = [];
                snapshot.forEach((doc) => {
                    if (doc.exists) {
                        tempNewArray = [
                            ...tempNewArray,
                            {
                              id: doc.id,
                              commentProduct: doc.data().commentProduct,
                              commentRating: doc.data().commentRating, 
                              commentDate: doc.data().commentDate,
                              displayName: doc.data().displayName,
                              profileImg: doc.data().profileImg,

                            },
                        ];

                       
                    }
                });


                setCommentLists([...commentLists, ...tempNewArray]);
                const currentCursorForNextPage = snapshot.docs[currentLenght -1];
                setCurrentCursor(currentCursorForNextPage);
            });
        });
    };










       //ADD COMMENT

       //const id = "cmp" + Math.random(999).toString();

       const [comment, onChangeComment] = React.useState("");
       const [rating, setRating] = useState(0);

    const submitCommentHandler = (e) => {
        
        e.preventDefault();
        
        const obj = {
    
            commentID: id,
            /* uid : uid,
            emailDisplay : emailDisplay, */
            merchantName : merchantName,
            displayName : displayName,
            //profileImg: profileImg,
            merchantID: merchantID,
            productID: productID,
            productName : productName,
            productImage : productImage,
            productCategory: productCategory,
            productSubCategory: productSubCategory,
            productTypeCategory: productTypeCategory,
    
            commentProduct : comment,
            commentRating : rating,
    
            commentDate: new Date(),
            
        };
    
        if (rating == 0) {
    
          Alert.alert("โปรดให้คะแนนสินค้า");
    
        } else {
    
          if (uid != null) {
    
            //addCommentHandler(obj);
    
            setRating(0);
            onChangeComment("");
    
            Alert.alert("เพิ่มความคิดเห็นสำเร็จ");
    
          } else {
    
              Alert.alert("เข้าสู่ระบบ/สร้างบัญชี เพื่อเพิ่มความคิดเห็น");
    
          }
    
        }
    }




















































        

        //RATING
        const [ratingSum, setRatingSum] = useState(0);
        const [ratingCount, setRatingCount] = useState(0);

        //SELECT PRODUCT QUANTITY
        const [count, setCount] = useState(1);
        const [calculation, setCalculation] = useState(0);

        //COMMENT
        //SHOW DISPLAY NAME
        const [displayNameShown, setDisplayNameShown] = useState(true);
        
        //READ MORE
        const [showMore, setShowMore] = useState(true);

        const [userID, setUserID] = useState("");

        const [currentUser, setCurrentUser] = useState(null);
        //const authContext = useContext(AuthContext);

        const [displayName, setDisplayName] = useState("");
    
        var user = auth.currentUser;
        var email, uid, name;
        var hiddenEmail;
        var hiddenDisplayName;


        if (user != null) {
          
            user.reload();
            // user.updateProfile(auth.currentUser, {displayName});
            uid = user.uid;
            email = user.email;
            name = user.displayName;
            console.log(name);
            // setUserID(uid);
            
           /*  const auth = authContext.currentUser;
            console.log(auth.displayName); */
            /* setUserID(uid);
            console.log(userID); */

            hiddenEmail = email.charAt(0) + email.replace(/./g, '*') + email.charAt(email.length-1)
            
            // console.log(uid);

            // console.log(user.displayName);
            
        } else {
            // signUpPage();
        }

      /* const docRef = firestore.collection("user"); 
      const query = docRef
          .where("uid", "==", uid);
      query
          .get()
          .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                  if (doc.exists) {
                      console.log(doc.data().displayName);
                  }
              });
          })
          .catch((err) => {
              console.error( 'ERROR LOAD DISPLAYNAME' +(err));
          }); */



          useEffect(() => {
        
            if (!!user) {
                setDisplayName(email);
            } else {
                
            }
         
          }, [user]); 






        



        const navigate = useNavigate();

        const refreshPage = () => {
            navigate(0);
        }
    
        const signUpPage = () => {
            navigate("/SignUp");
        }
    
    




        //ADD TO CART/////////////////////////////////////////////////////////////////////////////////

        const [show, setShow] = useState(false);

        const addDataCartHandler = (obj) => {
           
            const ref = firestore.collection("cart");
            ref
                //.doc(ref)
                //.doc(id)
                .add(obj)
                .then(() => {
                    console.log("เพิ่มข้อมูลสำเร็จ");
                    //console.log(ref.doc().id)
                    // refreshPage();
                })
                .catch((err) => console.log(err));
        };



        

    


      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

   
    //SET DISPLAY NAME
     
    const toggleDisplayName = () => {

        setDisplayNameShown(!displayNameShown);

    };

    useEffect(() => {

        
        if (displayNameShown) {
        
            setDisplayName(email);

        } else {

            setDisplayName(hiddenEmail);

        }

    }, [displayNameShown]);





    const [showAddCouponCode, setShowAddCouponCode] = useState(false);
    const handleCloseAddCouponCode = () => setShowAddCouponCode(false);

    const [showSaleCouponCode, setShowSaleCouponCode] = useState(false);
    const handleCloseSaleCouponCode = () => setShowSaleCouponCode(false);

    const [showSuccessSaleCouponCode, setShowSuccessSaleCouponCode] = useState(false);
    const handleCloseSuccessSaleCouponCode = () => setShowSuccessSaleCouponCode(false);
    
          
          
    
          // ฟังก์ชันสำหรับสร้าง array ที่มีสมาชิกเป็นค่าตัวเลขสุ่ม
            function generateRandomArray(size) {
                let randomArray = [];
                for (let i = 0; i < size; i++) {
                    randomArray.push("cc" + Math.random(999).toString()); // ตัวเลขสุ่มระหว่าง 0 ถึง 99
                }
                return randomArray;
            }
    
          // สร้าง Array ที่มีสมาชิก 100 ตัว
            let randomArray = generateRandomArray(10);
            console.log(randomArray);
    
    
          // ฟังก์ชันสำหรับกำหนดข้อมูลที่จะเพิ่ม Array ใน Product
          const submitHandler = (e) => {
            e.preventDefault();
            //var productKeywordArr = productKeyword.toString().split(",");
            const obj = {
                
                couponcodeMerchantios :  couponcodeMerchantios.concat(randomArray),
                couponcodeUserios : couponcodeUserios.concat(randomArray),
    
            };
          
        
            editHandler(obj);
        };
    
    
        // ฟังก์ชั่นสำหรับเพิ่มข้อมูลใน Firestore ใน field ชื่อ couponcodeMerchantios, couponcodeUserios
        const editHandler = (obj) => {
            
            const ref = firestore.collection("product");
            ref
                .doc(productID)
                .update(obj)
                .then(() => {
    
                    handleCloseAddCouponCode();
                    // setShow(true);
                    
                })
                .catch((err) => console.log(err));
        };



        /////////
        // ฟังก์ชันสำหรับการลบข้อมูล Coupon Code ที่ขายแล้ว ใน Array couponcodeMerchantios ใน product 
        const deleteSelectCouponCodeMerchantios = (couponcode) => {
        var index = couponcodeMerchantios.indexOf(couponcode);
            if (index >= 0) {
                //เรียกใชฟังก์ชั่นเพิ่มข้อมูลลงใน Library และเพิ่มจำนวนการขาย ก่อนดำเนินการลบ couponcodeUserios
                submitOrderHandler();


                couponcodeMerchantios.splice( index, 1 );
            }

            const obj = {
                couponcodeMerchantios : couponcodeMerchantios,
            }
        
            const ref = firestore.collection("product");
            ref
                
                .doc(productID)
                .update(obj)
                .then(() => {
                    handleCloseSaleCouponCode();
                    setShowSuccessSaleCouponCode(true);
                    // Alert.alert("นำออกจาก Coupon Code สำเร็จ")
                    
                })
                .catch((err) => console.log(err));

        };




        // ฟังก์ชันสำหรับการเพิ่มข้อมูลการขายสินค้าที่ขายได้ลงใน Order เพื่ออัพเดทยอดขาย (หลังจากกด "ขาย Coupon Code") 
        // (ใน Library จะเพิ่มต่อเมื่อคนซื้อกดใช้ Coupon Code /เนื่องจากไม่ทราบว่าคนซื้อ หรือผู้ใดจะใช้ Coupon Code)
    
        const id = "weboid" + Math.random(999).toString();

    const submitOrderHandler = (e) => {
        
        //e.preventDefault();
        //downloadFile();
        const obj = {

            customerID : uid,
            displayName: displayName,
            //profileImg: profileImg,
            productID : productID,
            orderID : id,
            merchantID : merchantID,
            merchantName : merchantName,
            productImage : productImage,
            productName : productName,
            productCaption: productCaption,
            productCategory: productCategory,
            productSubCategory: productSubCategory,
            productTypeCategory: productTypeCategory,
            productBadge: productBadge,
            productFullPrice: productFullPrice,
            productPrice: productPrice,
            productDiscount: productDiscount,
            productDescription: productDescription,
            productRatingSum : productRatingSum,
            productRatingCount : productRatingCount,
            productRelease : productRelease,
            productDate: productDate,

            perchaseDate: new Date(),
            productPdf: productPdf,
            pdfFilePath: pdfFilePath,

            productReciept: productReciept,

            productType: productType,

            bookPlatform: "web",

            //readStatus: 0,
            readStatus: 1,
            readCount: 0,

            favoriteBook : 0,
            showInLibrary: 1,

            productKeyword: productKeyword,

            couponcodeios: couponcodeMerchantios[1],

        };


        addOrderHandler(obj);


    };

    //const orderid = "weborderlib" + Math.random(999).toString();

    const addOrderHandler = (obj) => {

      
       // downloadFile();

        const ref = firestore.collection("order");
        ref
           
            .doc(id)
            .set(obj)
            .then(() => {
                
                addSaleCountHandler();
                
            })
            .catch((err) => console.log(err));
    };

    const addSaleCountHandler = () => {

      /* var index = wishlist.indexOf(uid);
      if (index >= 0) {
        wishlist.splice( index, 1 );
      } */

      const objProduct = {
        saleCount: saleCount + 1,
        //wishlist : wishlist,
      }

      const ref = firestore.collection("product");
      ref
         
          .doc(productID)
          .update(objProduct)
          .then(() => {

              //navigation.navigate('CheckOutSuccess');
              
          })
          .catch((err) => console.log(err));

    };



    const [showApproveSale, setShowApproveSale] = useState(false);
    const handleCloseApproveSale = () => setShowApproveSale(false);

    const [showPauseSale, setShowPauseSale] = useState(false);
    const handleClosePauseSale = () => setShowPauseSale(false);

    const approveProduct = () => {

    

        const objBook = {
          publicWebStatus: 1,
        }
  
        const ref = firestore.collection("product");
        ref
            .doc(productID)
            .update(objBook)
            .then(() => {

                handleCloseApproveSale();
                
            })
            .catch((err) => console.log(err));
  
    };
  
    const pauseProduct = () => {
  
      
  
      const objBook = {
        publicWebStatus: 0,
      }
  
      const ref = firestore.collection("product");
      ref
          .doc(productID)
          .update(objBook)
          .then(() => {

            handleClosePauseSale();
              
          })
          .catch((err) => console.log(err));
  
  };
    



    
    return (

        <>
        
      
            <Container w-75x>

                <br/>

                {/* <p><strong><Link to={"/ProductCategory"} state={productCategory} style={{textDecoration: 'none', color: "darkblue"}}>{productCategory}</Link> {">"} <Link to={"/ProductSubCategory"} state={productSubCategory} style={{textDecoration: 'none', color: "darkblue"}}>{productSubCategory}</Link> {">"}  <Link to={"/ProductTypeCategory"} state={productTypeCategory} style={{textDecoration: 'none', color: "darkblue"}}>{productTypeCategory}</Link></strong></p> */}
                <p><strong>{productCategory} {">"} {productSubCategory} {">"} {productTypeCategory}</strong></p>

              

                <br/>

                <Row>

                    {/* Row 1 Product Image Left */}
                    <Col>
                   
                    <img class='productimage' src={productImage} rounded />
                    </Col>
                    

              
                    <Col sm>
                    <br/>
                        <h4><strong>{productName}</strong></h4>
                        <p>ร้านค้า : {merchantName}<br/>
                        ประเภทสินค้า : {productType}<br/>
                        วันที่ตีพิมพ์ : {productRelease}<br/>
                        วันที่จำหน่าย : {productDate}<br/>
                        {/* <span style={{color: 'goldenrod'}}>จำนวน Coupon Code : {couponcodeMerchantios.length - 1}</span><br/> */}

                           

                                                    { (productRatingSum / productRatingCount) <= 0 ? (
                                                            <>
                                                            
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 1 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod'}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStar/> <BsStar/> <BsStar/> <BsStar/></span> <span style={{position: "relative", top: 3, fontSize: 16}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 1.5 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarHalf/> <BsStar/> <BsStar/> <BsStar/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 2 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStar/> <BsStar/> <BsStar/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 2.5 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStarHalf/> <BsStar/> <BsStar/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 3 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStar/> <BsStar/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 3.5 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarHalf/> <BsStar/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 4 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStar/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) <= 4.5 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarHalf/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (productRatingSum / productRatingCount) > 4.5 ? (
                                                            <>
                                                                <span style={{position: "relative", top: 3, fontWeight: 'bolder', color: 'goldenrod', fontSize: 16}}>{(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}</span> <span style={{color: "orange", fontSize: 13}}> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/></span> <span style={{position: "relative", top: 2, fontSize: 15}}>({productRatingCount})</span>{' '}
                                                            </>
                                                        ) : (
                                                            <>
                                                                
                                                            </>
                                                        ) }
                            
                        </p>


                                                   

                                                    <br/>
                    

                        
                                                        <h5>ราคาในแอพพลิเคชั่น{formatter.format(productPrice)} <del style={{color: "gray"}}>{formatter.format(productFullPrice)}</del></h5>
                                                        <h5>ราคาในเว็บไซต์{formatter.format(productWebPrice)} <del style={{color: "gray"}}>{formatter.format(productFullPrice)}</del></h5>
                        
                           
                        <p>

                        <strong>ขายแล้ว:</strong><span style={{color:"green"}}> {saleCount}</span><br/>

                        <br/>

                        {publicWebStatus == 0 ? (

                        <>

                                <Button variant="outline-success" onClick={() => setShowApproveSale(true)}>
                                    อนุมัติจำหน่ายในเว็บ
                                </Button>


                        </>


                        ) : (

                        <>

                                <Button variant="outline-danger" onClick={() => setShowPauseSale(true)}>
                                    หยุดจำหน่ายในเว็บ
                                </Button>


                        </>

                        )}
                        </p>


                        <Modal 
                            show={showApproveSale} 
                            onHide={handleCloseApproveSale} 
                            animation={false} 
                            size="m"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>
                        
                            <Modal.Header>
                                <Modal.Title>อนุมัติการจำหน่ายในเว็บไซต์</Modal.Title>
                            </Modal.Header>
                                                                  
                            <Modal.Body>
                                ยื่นยันการจำหน่ายหนังสือ {productName} และแสดงผลเพื่อจำหน่ายในเว็บไซต์
                            </Modal.Body>
                        
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseApproveSale}>
                                    ยกเลิก
                                </Button>
                                <Button variant="success" onClick={() => approveProduct(productID)}>
                                    อนุมัติ
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal 
                            show={showPauseSale} 
                            onHide={handleClosePauseSale} 
                            animation={false} 
                            size="m"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>
                        
                            <Modal.Header>
                                <Modal.Title>หยุดจำหน่ายในเว็บไซต์</Modal.Title>
                            </Modal.Header>
                                                                  
                            <Modal.Body>
                                ยื่นยันการหยุดจำหน่ายหนังสือ {productName} และหยุดแสดงผลเพื่อจำหน่ายในเว็บไซต์
                            </Modal.Body>
                        
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClosePauseSale}>
                                    ยกเลิก
                                </Button>
                                <Button variant="success" onClick={() => pauseProduct(productID)}>
                                    หยุดจำหน่าย
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal 
                            show={showSaleCouponCode} 
                            onHide={handleCloseSaleCouponCode} 
                            animation={false} 
                            size="m"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>
                        
                            <Modal.Header>
                                <Modal.Title>การขาย Coupon Code</Modal.Title>
                            </Modal.Header>
                                                                  
                            <Modal.Body>
                                ยื่นยันการขายหนังสือ {productName} รหัส Coupon Code : {couponcodeMerchantios[1]} ในระบบ ios/Android
                            </Modal.Body>
                        
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseSaleCouponCode}>
                                    ยกเลิก
                                </Button>
                                <Button variant="success" onClick={() => deleteSelectCouponCodeMerchantios(couponcodeMerchantios[1])}>
                                    ขาย Coupon Code
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal 
                        show={showSuccessSaleCouponCode} 
                        onHide={handleCloseSuccessSaleCouponCode} 
                        animation={false} 
                        size="m"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered>
                                                                        
                            <Modal.Header>
                                <Modal.Title>ขาย Coupon Code สำเร็จ</Modal.Title>
                            </Modal.Header>
                                                                                                                    
                            <Modal.Body>
                                เพิ่มข้อมูลการขายสำเร็จ
                            </Modal.Body>
                                                                            
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseSuccessSaleCouponCode}>
                                    ตกลง
                                </Button>       
                            </Modal.Footer>
                        </Modal>


                        <Modal 
                            show={showAddCouponCode} 
                            onHide={handleCloseAddCouponCode} 
                            animation={false} 
                            size="m"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>
                        
                            <Modal.Header>
                                <Modal.Title>เพิ่ม Coupon Code</Modal.Title>
                            </Modal.Header>
                                                                  
                            <Modal.Body>
                                เพิ่ม Coupon Code หนังสือ {productName} เพื่อจำหน่ายในระบบ ios/Android {productID}
                            </Modal.Body>
                        
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseAddCouponCode}>
                                    ยกเลิก
                                </Button>
                                <Button variant="primary" onClick={submitHandler}>
                                    เพิ่ม Coupon Code
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* <Alert show={show} variant="success">
                            <Alert.Heading>เพิ่ม Coupon Code สำเร็จ</Alert.Heading>
                            <p>
                                เพิ่ม Coupon Code สำหรับการขายสำเร็จ
                            </p>
                            <hr />
                            <div className="d-flex justify-content-end">
                            <Button onClick={() => setShow(false)} variant="outline-success">
                                ตกลง
                            </Button>
                            </div>
                        </Alert> */}

                        

                        <h3 className="pb-3 border-bottom"></h3><br/>

                        <p><span style={{color: 'goldenrod'}}>จำนวน Coupon Code คงเหลือ : {couponcodeMerchantios.length - 1}</span></p>
                        <h4><strong>การขาย</strong></h4>
                        <p>(ส่วนที่คัดลอกให้ลูกค้า)</p>
                     
                        <p>ชื่อหนังสือ : {productName} <br/>
                        รหัสสินค้า : {productID} <br/>
                        วันที่ทำรายการ : {purchaseDate.toLocaleDateString('th-TH', {year: 'numeric', month: 'long', day: 'numeric', weekday: 'short'})}<br/>
                        ระบบที่ใช้งาน : EduLaw - ios/Android <br/><br/>
                        --- ลิ้งค์สินค้า ---<br/>
                        edulawbooks.com/ProductView/{productID}<br/><br/>
                        
                        --- Coupon Code ---<br/>
                        {couponcodeMerchantios[1]}</p>

                        <br/>
                        
                        {/* <Button variant="info" className="rounded-0"><span style={{color:"white"}}>คัดลอก Coupon Code</span></Button>{' '}{' '} */}
                        <Button onClick={() => setShowSaleCouponCode(true)} variant="success" className="rounded-0"><span style={{color:"white"}}>ขาย Coupon Code</span></Button> <br/><br/>

                        <p style={{color: 'salmon', fontWeight: 'bold'}}>• เมื่อตรวจสอบการชำระเงินแล้ว คัดลอกข้อมูลหนังสือ ลิ้งค์สินค้า และ Coupon Code เพื่อส่งให้ลูกค้า<br/>
                        • กด "ขาย Coupon Code" เพื่อลบข้อมูล Coupon Code ที่ส่งให้ลูกค้าแล้วออกจากระบบ และเพื่ออัพเดทข้อมูลการขายสินค้า<br/>
                        
                        </p>

                        <h3 className="pb-3 border-bottom"></h3> 

                        <br/>

                        <h4><strong>จัดการ Coupon Code</strong></h4>

                        <br/>

                        <Button onClick={() => setShowAddCouponCode(true)} variant="dark" className="rounded-0"><span style={{color:"white"}}>เพิ่ม Coupon Code</span></Button>{' '}
                        <br/><br/>
                        <p style={{color: 'dodgerblue', fontWeight: 'bold'}}>• สามารถกดเพิ่ม Coupon Code เพื่อขายต่อไปได้ (ไม่ควรเพิ่มเกินจำนวน 100 - 200 หน่วย)<br/></p>
                        

                     

                        <h3 className="pb-3 border-bottom"></h3>
                        <a href="https://www.facebook.com/profile.php?id=100028543045358&mibextid=LQQJ4d" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "salmon"}}><p><FaFacebookMessenger/> แชทกับลูกค้า</p></a>
                        
                    </Col>

                </Row>

                <br/>
            

                {/* <Container>
                    <br/>

                    <Tabs defaultActiveKey="detail" id="uncontrolled-tab-example" className="mb-3">
                        <Tab eventKey="detail" title="รายละเอียด">
                            
                                
                                <h3><strong>รายละเอียดสินค้า</strong></h3>

                                
                                {!!productSamplePdf ? (
                                    <>
                                    <br/>
                                    <a href={productSamplePdf} target="_blank" rel="noreferrer"><Button variant="outline-info" className="rounded-0">ตัวอย่างหนังสือ</Button></a>
                                    <br/>
                                    </>
                                ) : (
                                    <></>
                                )}
                                
                                <br/>

                                <strong>วันวางจำหน่าย:</strong> {productRelease}<br/>
                                
                                
                                <p style={{whiteSpace: "pre-line"}}>{showMore ? <>{productDescription.replaceAll("<br/>", "\n").substring(0, 500)} ...</> : productDescription.replaceAll("<br/>", "\n") }  </p>
                                    <Button variant="outline-dark" className="rounded-0" onClick={() => setShowMore(!showMore)}>
                                        {showMore ? "อ่านเพิ่มเติม" : "อ่านน้อยลง"}
                                    </Button>

                                <br/>
                                <br/>
                            
                            
                        </Tab>

                       

                    </Tabs>

                    <h3 className="pb-3 border-bottom"></h3>
                    <br/>

                    <h3><strong>รีวิวสินค้า</strong></h3>

                    <br/>
                  
                    
                            {commentLists.map((item) => {
                                    
                                    return (
                                        <div key={item.id}>
                                    <Row xs='auto'>
                                        
                                        <Col><Button variant="dark" style={{width: 50, height: 50, marginTop: 7, fontSize: 20}} className="rounded-circle"><strong>{(item.email).slice("0", "1")}</strong></Button></Col>
                                        <Col xs={9} md={7} style={{marginTop: 5}}><strong>{item.displayName}</strong>
                                            <br/>
                                            { item.commentRating == 5 ? (
                                            <p><span style={{color: "orange", fontSize: 15}}><BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/></span></p>
                                            ) : item.rating == 4 ? (
                                            <p><span style={{color: "orange", fontSize: 15}}><BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStar/></span></p>
                                            ) : item.rating == 3 ? (
                                            <p><span style={{color: "orange", fontSize: 15}}><BsStarFill/> <BsStarFill/> <BsStarFill/> <BsStar/> <BsStar/></span></p>
                                            ) : item.rating == 2 ? (
                                            <p><span style={{color: "orange", fontSize: 15}}><BsStarFill/> <BsStarFill/> <BsStar/> <BsStar/> <BsStar/></span></p>
                                            ) : (
                                            <p><span style={{color: "orange", fontSize: 15}}><BsStarFill/> <BsStar/> <BsStar/> <BsStar/> <BsStar/></span></p>
                                            )}

                                            <p style={{position: "relative", top: -10, fontSize: 12}}>{(item.commentDate).toDate().toDateString()} | {(item.commentDate).toDate().toLocaleTimeString()}</p>
                                
       
                                 
                                            <p style={{whiteSpace: "pre-line", wordWrap: "break-word"}}>{(item.comment).replaceAll("<br/>", "\n")} </p>
                              

                                            <Col>
                       
                                            </Col>
                                            
                            
                                        </Col>
                                        </Row>
                                        <h3 className="pb-3 border-bottom"></h3>
                                        <br/>
                                        </div>

                                )
                            })}

                            {currentCursor ? (
                                <Col className='float-start'>

                                    <Button variant="warning" className="rounded-0" onClick={onMoreComment}>อ่านรีวิวเพิ่มเติม</Button>
                                    
                                </Col>
                                ) : (
                                <Col className='float-start'>

                                    <Button variant="outline-secondary" className="rounded-0" disabled>ไม่มีรีวิวสินค้า</Button>
                                    
                                </Col>
                            )}

                            <br/>
                            <br/>
                            <br/>
                            <br/>


                    {!!user ? (
                        <>
                        

                    <h3><strong>เขียนรีวิว</strong></h3>

                    <form onSubmit={submitCommentHandler}>
                    { rating == 0 ? (
                        <>
                        <Button onClick={() => setRating(1)} variant="none" style={{color: "darkgray", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(2)} variant="none" style={{color: "darkgray", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(3)} variant="none" style={{color: "darkgray", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(4)} variant="none" style={{color: "darkgray", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(5)} variant="none" style={{color: "darkgray", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        </>
                    ) : rating == 1 ? (

                        <>
                        <Button onClick={() => setRating(1)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(2)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(3)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(4)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(5)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        </>

                    ) : rating == 2 ? (

                        <>
                        <Button onClick={() => setRating(1)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(2)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(3)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(4)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(5)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        </>

                    ) : rating == 3 ? (

                        <>
                        <Button onClick={() => setRating(1)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(2)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(3)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(4)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        <Button onClick={() => setRating(5)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        </>

                    ) : rating == 4 ? (

                        <>
                        <Button onClick={() => setRating(1)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(2)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(3)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(4)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(5)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStar/></Button>
                        </>

                    ) : (

                        <>
                        <Button onClick={() => setRating(1)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(2)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(3)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(4)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        <Button onClick={() => setRating(5)} variant="none" style={{color: "orange", fontSize: 25, marginLeft: -7}} size="sm"><BsStarFill/></Button>
                        </>

                    ) }
                        <br/>
                        <br/>

                        
                            {displayNameShown ? (
                                
                                <p onClick={toggleDisplayName}>{displayName} <span style={{fontSize: 24}}>| <FaRegEye/></span> แสดง</p>
                
                            ) : (
                                <>
                                <p onClick={toggleDisplayName}>{displayName} <span style={{fontSize: 24}}>| <FaRegEyeSlash/></span> ไม่แสดง</p>
                                </>
                            )}
                        

                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                          
                            <Form.Control 
                                as="textarea" 
                                className="rounded-0"
                                style={{ whiteSpace: 'pre-line'}}
                                placeholder="รีวิว..."
                                rows={3} 
                                value={comment}
                                onChange={(e) => {
                                   
                                }}
                                        
                            />
                        </Form.Group>

                        <Button variant="dark" className="rounded-0" type="submit">ส่งรีวิว</Button>
                    </form>
                        </>
                    ) : (
                        <Link to={"/LogIn"}><Button variant="dark" className="rounded-0">เข้าสู่ระบบเพื่อรีวิว</Button></Link>
                    )}
                    



                    <br/>
                    <br/>
                    <br/>

                </Container> */}
                    

            </Container>

            


        
        </>
        

    );



}


export default ManageProductDetail;